import { TmsRouteType } from 'app/constants/tmsRouteType'

export const getTmsRouteTypeName = (type: TmsRouteType) => {
  let name = 'tmsRouteType.undefined'

  switch (type) {
    case TmsRouteType.Bilateral:
      name = 'tmsRouteType.bilateral'
      break
    case TmsRouteType.CrossTrade:
    case TmsRouteType.CrossTradeBilateral:
    case TmsRouteType.CrossTradeWrong:
      name = 'tmsRouteType.crossTrade'
      break
    case TmsRouteType.CrossTradeBilateralEmpty:
    case TmsRouteType.CrossTradeWrongEmpty:
      name = 'tmsRouteType.crossTradeEmpty'
      break
    case TmsRouteType.Cabotage:
      name = 'tmsRouteType.cabotage'
      break
    case TmsRouteType.CabotageEmpty:
      name = 'tmsRouteType.cabotageEmpty'
      break
    case TmsRouteType.Import:
      name = 'tmsRouteType.import'
      break
    case TmsRouteType.Export:
      name = 'tmsRouteType.export'
      break
    case TmsRouteType.Transit:
      name = 'tmsRouteType.transit'
      break
    case TmsRouteType.PolishTransit:
      name = 'tmsRouteType.polishTransit'
      break
    case TmsRouteType.Empty:
      name = 'tmsRouteType.empty'
      break
    case TmsRouteType.Domestic:
      name = 'tmsRouteType.domestic'
      break
  }

  return name
}
